module.exports = __webpack_public_path__ + "static/media/titlev2.8f8796a8.png";